// Breakpoints for the Contacts button row (PROPS-3311, "My Contacts Button Row" Figma spec).
// The group context determines which set applies:
//
// With Skip Tracing Status shown (append groups):
//   >= 1420px   - everything visible
//   1270-1419px - only the "Skip Tracing Status" label collapses to a dot
//   1170-1269px - also hide Import & Export text
//   <= 1169px   - also hide New Contact & Skip Trace text
//
// Without Skip Tracing Status (regular groups, no status indicator to collapse):
//   >= 1250px   - everything visible
//   1150-1249px - hide Import & Export text
//   <= 1149px   - also hide New Contact & Skip Trace text
const WITH_STATUS_BREAKPOINTS = {
  status: 1420,
  importExport: 1270,
  newContactAndSkipTrace: 1170,
};

const WITHOUT_STATUS_BREAKPOINTS = {
  importExport: 1250,
  newContactAndSkipTrace: 1150,
};

const getButtonVisibility = (width, hasSkipTracingStatus) => {
  const breakpoints = hasSkipTracingStatus ? WITH_STATUS_BREAKPOINTS : WITHOUT_STATUS_BREAKPOINTS;

  return {
    hideStatusText: hasSkipTracingStatus ? width < breakpoints.status : false,
    hideImportExportText: width < breakpoints.importExport,
    hideNewContactText: width < breakpoints.newContactAndSkipTrace,
    hideSkipTraceText: width < breakpoints.newContactAndSkipTrace,
  };
};

export default getButtonVisibility;
